import { render, staticRenderFns } from "./addNewCustom.vue?vue&type=template&id=4016cdb6&scoped=true&"
import script from "./addNewCustom.vue?vue&type=script&lang=js&"
export * from "./addNewCustom.vue?vue&type=script&lang=js&"
import style0 from "./addNewCustom.vue?vue&type=style&index=0&id=4016cdb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4016cdb6",
  null
  
)

export default component.exports